const angular = require('angular');
var app = angular.module('learn-controllers');
const moment = require('moment');

/**
 * User Dashboard Controller
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.controller('userDashboardController', [
  'Application', 
  'Authorization',
  'Users',
  '$location',
  '$scope',
  'UserTracks',
  '$q',
  function (Application, Authorization, Users, $location, $scope, UserTracks, $q) {
    var self = this;
    self.authtoken = Authorization.getAuthToken();
    self.flags = Application.features.flags();
    self.user = self.authtoken.user;
    self.routeParameters = Application.navigation.getRouteParameters();
    self.imported_content =
      (Authorization.getAuthToken().company &&
        (Authorization.getAuthToken().company.udemy ||
          Authorization.getAuthToken().company.linkedin_learning ||
          Authorization.getAuthToken().company.scorm)) ||
          self.flags.enable_masterclass || false;

    var mainTabOptions = {
      activity: true,
      tracks: true,
      assignments: true,
      settings: true,
      certificates: true,
      courses: true,
      workshops: true,
      badges: true,
    };
    self.certificatesChecked = false;
    self.banner_image = '';

    self.currentTab = 'assignments';
    self.currentMainTab = 'activity';
    if (self.routeParameters && self.routeParameters.location && mainTabOptions[self.routeParameters.location]) {
      if (self.routeParameters.location === 'certificates') {
        self.currentTab = 'certificates';
        self.certificatesChecked = true;
      } else if (self.routeParameters.location === 'tracks') {
        self.currentTab = 'tracks';
        self.tracksChecked = true;
      } else if (self.routeParameters.location === 'workshops') {
        self.currentTab = 'workshops';
        self.workshopsChecked = true;
      } else if (self.routeParameters.location === 'courses') {
        self.currentTab = 'imported_content';
        self.coursesChecked = true;
      } else if (self.routeParameters.location === 'badges') {
        self.currentTab = 'badges';
        self.badgesChecked = true;
      }else {
        self.currentMainTab = self.routeParameters.location;
        self.activityChecked = true;
      }
    }

    self.setTab = function (tab, link, check) {
      self.currentTab = tab;
      self.setLink(link);
      self[check] = true;
    };

    self.setLink = function(type) {
      $location.path('/dashboard/' + type);
    };

    self.initialize = function () {
      if (Authorization.hasValidAuthToken()) {
        $q.all([
          Users.get({
            subresource: self.user._id,
            fields: 'first_name,last_name,email,role,banner_image,image',
          }).$promise,
          UserTracks.find({
            user: self.user._id,
            fields: 'completed_date',
          }).$promise,
        ]).then(function (results) {
          var user = results[0];
          var userTracks = results[1];

          self.completedTracks = userTracks.filter((track) => track.completed_date).length;
          self.openTracks = userTracks.filter((track) => !track.completed_date).length;

          if (user.banner_image) {
            self.banner_image =
              Application.imageCdn.baseUrl +
              Application.imageCdn.sharedProps +
              ',' +
              'q_auto:eco' +
              '/' +
              user.banner_image;
          } else {
            self.banner_image = '';
          }
          self.findFrom = moment().startOf('month').subtract(6, 'months').format('MMM YYYY');
        });
        return;
      }
      if (Application.navigation.isRouteSecure()) {
        Application.navigation.goToSignIn();
      }
    };

    self.initialize();
  }]);
